// mc-delivery.js, the postcode delivery checker (audit-2026-09-18, metro rule 2026-09-26, plain answers 2026-10-16).
// Wires every [data-mc-delivery] block on the page (the product page buy box, the lower delivery band and the cart
// assurance section). Metro postcodes are told delivery is free. Every other postcode is told a fee may apply, that
// checkout shows the exact price before anything is paid, and how to find out first (email or a free call). Every answer
// ends with the hold dispatch line, because people moving house asked and nothing answered them.
// The metro list is window.MC_ZONES from assets/mc-delivery-zones.js (built by build-zones.mjs), which must run first.
// The delivery window comes from window.MC_FACTS (assets/mc-facts.js) when present. No phone number, ever.
// The postcode is remembered in localStorage (mc_postcode), shared by every checker on the site, and a remembered
// postcode shows its answer straight away. Other code can read the answer through window.MCDelivery and listen for the
// mc:postcode event on document.
(function () {
  'use strict';

  var STORAGE_KEY = 'mc_postcode';
  var EMAIL = 'info@mattresscrafters.com.au';
  var CALL_URL = '/pages/sleep-consultation';

  function readStoredPostcode() {
    try { return window.localStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }
  function storePostcode(pc) {
    try { window.localStorage.setItem(STORAGE_KEY, pc); } catch (e) { /* private window or blocked storage, ignore */ }
  }

  function facts() { return window.MC_FACTS || {}; }
  function deliveryWindow() { return facts().deliveryWindow || '2 to 12'; }

  function zoneOf(postcode) {
    var zone = window.MC_ZONES && window.MC_ZONES[postcode];
    if (zone && zone[1] === 'free-nextday') return 'free-nextday';
    if (zone && zone[1] === 'free') return 'free';
    return 'other';
  }

  function placeName(postcode) {
    var zone = window.MC_ZONES && window.MC_ZONES[postcode];
    return zone && zone[0] ? zone[0] + ' ' + postcode : 'postcode ' + postcode;
  }

  function holdLine() {
    // bundle-ux round 5: the cart page has an order note for this (builder B4, [data-mc-cart-note]). Where the note is on
    // the same page (the cart page, where it sits in the cart above this checker) the line points at it.
    var where = 'the note on the cart page';
    var note = document.querySelector('[data-mc-cart-note]');
    var box = document.querySelector('[data-mc-delivery]');
    if (note && box) where = (note.compareDocumentPosition(box) & 4) ? 'the note above' : 'the note below';
    return '<span class="mcbt-hold">Need it later, for example after a move? Write the date in ' + where + ' and we will hold dispatch.</span>';
  }

  function resultMarkup(postcode) {
    var where = '<b>' + placeName(postcode) + '</b>';
    var z = zoneOf(postcode);
    var main;
    if (z === 'free-nextday') {
      main = 'Free delivery to ' + where + ', and most Melbourne metro orders arrive the next business day.';
    } else if (z === 'free') {
      main = 'Free delivery to ' + where + ', usually ' + deliveryWindow() + ' business days from dispatch.';
    } else {
      main = 'Delivery to ' + where + ' is outside our free metro areas, so a delivery fee may apply. It usually arrives ' + deliveryWindow() + ' business days after dispatch. The exact price shows at checkout once you type your address, before you pay anything. To know it first, email <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> or <a href="' + CALL_URL + '">book a free call</a>.';
    }
    return main + holdLine();
  }

  function showResult(block, html, state) {
    var result = block.querySelector('[data-mc-result]');
    if (!result) return null;
    result.innerHTML = html;
    result.hidden = false;
    if (state) result.setAttribute('data-state', state); else result.removeAttribute('data-state');
    return result;
  }

  // The fixed bar along the top (a sticky header) and along the bottom (the product page sticky bar) at the middle of
  // the screen, so the answer can be scrolled clear of both.
  function fixedEdge(y) {
    var el = document.elementFromPoint ? document.elementFromPoint(window.innerWidth / 2, y) : null;
    while (el && el !== document.body && el !== document.documentElement) {
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') return el.getBoundingClientRect();
      el = el.parentElement;
    }
    return null;
  }

  function keepInView(block, result) {
    if (!result || !result.getBoundingClientRect) return;
    var topBar = fixedEdge(12);
    var bottomBar = fixedEdge(window.innerHeight - 2);
    var top = topBar && topBar.bottom < window.innerHeight / 2 ? topBar.bottom : 0;
    var bottom = bottomBar && bottomBar.top > window.innerHeight / 2 ? bottomBar.top : window.innerHeight;
    // room for the round chat button that sits just above the bottom bar on phones
    var clear = window.innerWidth <= 640 ? 72 : 24;
    var box = block.getBoundingClientRect();
    var r = result.getBoundingClientRect();
    var delta = 0;
    if (r.bottom > bottom - clear) delta = r.bottom - (bottom - clear);
    if (box.top - delta < top + 8) delta = box.top - top - 8;
    if (Math.abs(delta) > 2) window.scrollBy({ top: delta, behavior: 'smooth' });
  }

  function announce(postcode) {
    try {
      document.dispatchEvent(new CustomEvent('mc:postcode', { detail: { postcode: postcode, zone: zoneOf(postcode), place: placeName(postcode) } }));
    } catch (e) { /* old browser without CustomEvent, the stored postcode still works */ }
  }

  function check(block) {
    var input = block.querySelector('[data-mc-postcode]');
    if (!input) return;
    var postcode = (input.value || '').trim();
    if (!/^\d{4}$/.test(postcode)) {
      keepInView(block, showResult(block, 'Enter a 4 digit postcode.', 'error'));
      return;
    }
    storePostcode(postcode);
    // keep every instance on the page in sync, answer included
    var blocks = document.querySelectorAll('[data-mc-delivery]');
    for (var i = 0; i < blocks.length; i++) {
      var inp = blocks[i].querySelector('[data-mc-postcode]');
      if (inp) inp.value = postcode;
      if (blocks[i] !== block) showResult(blocks[i], resultMarkup(postcode));
    }
    keepInView(block, showResult(block, resultMarkup(postcode)));
    announce(postcode);
  }

  function wire(block) {
    if (block.getAttribute('data-mc-wired')) return;
    block.setAttribute('data-mc-wired', '1');
    var input = block.querySelector('[data-mc-postcode]');
    var btn = block.querySelector('[data-mc-check]');
    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 4);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); check(block); }
      });
      var stored = readStoredPostcode();
      if (/^\d{4}$/.test(stored)) {
        input.value = stored;
        showResult(block, resultMarkup(stored));
      }
    }
    if (btn) btn.addEventListener('click', function () { check(block); });
  }

  function wireAll() {
    var blocks = document.querySelectorAll('[data-mc-delivery]');
    for (var i = 0; i < blocks.length; i++) wire(blocks[i]);
  }

  window.MCDelivery = {
    answer: resultMarkup,
    zone: zoneOf,
    place: placeName,
    stored: readStoredPostcode
  };

  function init() {
    wireAll();
    var app = document.getElementById('app');
    if (app && window.MutationObserver) {
      var mo = new MutationObserver(wireAll);
      mo.observe(app, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
